import React, { useEffect } from 'react';
import './About.css';
import CallMadeIcon from '@material-ui/icons/CallMade';
import {Link} from 'react-router-dom';
import { Grid, Container } from '@material-ui/core';
import undraw_software from './images/undraw_software.svg';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import CardTravelIcon from '@material-ui/icons/CardTravel';
import BusinessIcon from '@material-ui/icons/Business';
import undraw_gradution from './images/undraw_graduation.svg';
import undraw_education from './images/undraw_education.svg';
import CodeIcon from '@material-ui/icons/Code';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

function About() { 
    useEffect(() => {
        const steps = document.querySelectorAll(".step");
        console.log('steps inside useeffet ',steps);
        steps.forEach(item => {
            item.addEventListener("mouseover",() => {
                for(let i=0;i<steps.length;i++){
                    steps[i].classList.remove('completed');
                }
                item.classList.add('completed');
            })
        })
    }, [])
    
        
    return (
        <div className='about_page whole_page backgroundblack'>
            <div className='about_text'>
                <Link to = '/' >
                    <CallMadeIcon fontSize="inherit" style={{fontSize:100}} className='about_backIcon' />
                </Link>
                
                <h2>Hi, this is chivte krishna software developer engineer focused on UI and developing apps.</h2>
            </div>
            <div className='about_introDiv'>
                <div className='about_intro'>
                <p>I am passionate about developing websites with a strong visual identity. It helps digital brands and companies move to the next level and increase user engagement.
                    I always feel building and developing things is like playing video games and its fun. 
                </p>
                </div>
            </div>

            <Container maxwidth='md'
             style={{width:'100%',marginTop:'2rem',color:'white'}}>
                <h1 className='center marginbottom'>Work and Education</h1>
                <div className="step completed" id="div1" >
                <div className="v-stepper">
                    <div className="circle center">1</div>
                    <div className="line"></div>
                    <div className="line2"></div>
                </div>

                <Grid container spacing={2} style={{padding:'0 1rem'}}>
                    <Grid item xs={12} sm={12} md={6}>
                        <img src={undraw_software} className='setimage'></img>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                    <div className='flex1 flexvertical'>
                        <div className='flex1 marginbottom' style={{marginTop:'1rem'}}>
                            <BusinessIcon style={{fontSize:30,marginRight:'2rem'}}/> 
                            <h3>Finnovation tech solutions</h3>
                        </div>
                        <div className='marginbottom flex1'>
                            <CodeIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Software Engineer</p>
                            </div>
                        <div className='flex1 marginbottom'>
                            <LocationOnIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Bangalore</p>
                            </div>
                        <div className='flex1 marginbottom'>
                            <AccessTimeIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Start: 22nd March,  End: Present</p>
                            </div>
                        <div className='flex1 marginbottom'>
                            <CardTravelIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Time Period : 6 months</p>
                            </div>
                        <div className='marginbottom'>
                            <ul>
                            <li>Wrote automated test scripts (cypress, yml).</li>
                            <li>Responsive designs and data handling with redux saga.</li>
                            <li>Solved live issues</li>
                            <li>Worked on AWS services lambdas, api gateway, cloud watch etc,</li>
                            </ul></div>
                    </div>
                    </Grid>
                </Grid>
                </div>
                <div className="step" id="div2" >
                <div className="v-stepper">
                    <div className="circle center">2</div>
                    <div className="line"></div>
                    <div className="line2"></div>
                </div>
                <Grid container spacing={2} style={{padding:'0'}}>
                    <Grid item xs={12} sm={12} md={6}>
                        <img src={undraw_software} className='setimage'></img>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} >
                    <div className='flex1 flexvertical'>
                        <div className='flex1 marginbottom' style={{marginTop:'1rem'}}>
                            <BusinessIcon style={{fontSize:30,marginRight:'2rem'}}/> 
                            <h3 >Karma Labs</h3>
                        </div>
                        <div className='marginbottom flex1'>
                            <CodeIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Developer</p>
                            </div>
                        <div className='flex1 marginbottom'>
                            <LocationOnIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Bangalore</p>
                            </div>
                        <div className='flex1 marginbottom'>
                            <AccessTimeIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Start: 14 January,  End: 14 March</p>
                            </div>
                        <div className='flex1 marginbottom'>
                            <CardTravelIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Time Period : 2 months</p>
                            </div>
                        <div className='marginbottom'>
                            <ul>
                            <li>Used to get data from backend and write to the frontend maintaining the redux state.</li>
                            <li>Design responsive pages using css and material UI.</li>
                            <li>Made the whole admin part frontend</li>
                            </ul></div>
                    </div>
                    </Grid>
                </Grid>

                
                </div>
                <div className="step " >
                <div className="v-stepper">
                    <div className="circle center">3</div>
                    <div className="line"></div>
                    <div className="line2"></div>
                </div>

                <Grid container spacing={2} style={{padding:'0 1rem'}}>
                    <Grid item xs={12} sm={12} md={6} id="grid3_1">
                        <img src={undraw_gradution} className='setimage image32'></img>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} id="grid3_2">
                    <div className='flex1 flexvertical'>
                        <div className='flex1 marginbottom' style={{marginTop:'1rem'}}>
                            <BusinessIcon style={{fontSize:30,marginRight:'2rem'}}/> 
                            <h3 >Bachelor of Technology(B.Tech)</h3>
                        </div>
                        <div className='marginbottom flex1 nothing'>
                            <CodeIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Computer Science Engineering</p>
                            </div>
                        <div className='flex1 marginbottom nothing'>
                            <LocationOnIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>kalyani,kolkata,West Bengal.</p>
                            </div>
                        <div className='flex1 marginbottom nothing'>
                            <AccessTimeIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Start: Aug 2016,  End: May 2020</p>
                            </div>
                        <div className='flex1 marginbottom nothing'>
                            <CardTravelIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Time Period : 4 Years</p>
                            </div>
                    </div>
                    </Grid>
                </Grid>
                </div>
                
                <div className="step" id="div4" >
                <div className="v-stepper">
                    <div className="circle center">4</div>
                    <div className="line"></div>
                    <div className="line2"></div>
                </div>

                <Grid container spacing={2} style={{padding:'0 1rem'}}>
                    <Grid item xs={12} sm={12} md={6}>
                        <img src={undraw_education} className='setimage'></img>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} >
                    <div className='flex1 flexvertical'>
                        <div className='flex1 marginbottom' style={{marginTop:'1rem'}}>
                            <BusinessIcon style={{fontSize:30,marginRight:'2rem'}}/> 
                            <h3 >Senior Secondary</h3>
                        </div>
                        <div className='marginbottom flex1'>
                            <CodeIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Maths, Physics, Chemistry.</p>
                            </div>
                        <div className='flex1 marginbottom'>
                            <LocationOnIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Hyderabad, Telangana</p>
                            </div>
                        <div className='flex1 marginbottom'>
                            <AccessTimeIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Start: June 2014,  April: 2016</p>
                            </div>
                        <div className='flex1 marginbottom'>
                            <CardTravelIcon style={{fontSize:30,marginRight:'2rem'}}/>
                            <p>Time Period : 2 Years</p>
                            </div>
                    </div>
                    </Grid>
                </Grid>
                </div>
<hr style={{marginLeft:'10%'}}></hr>  
            </Container>
            
        </div>
    )
}

export default About
